import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Chrome } from "@uiw/react-color";
import { Input } from "../Input";
import Popover from "../Popover";

const ColorPicker = (props) => {
  const { placeholder, onChange, value } = props;
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const inputRef = useRef(null);

  const handleColorChange = (color) => {
    onChange?.(color);
  };

  return (
    <div className="color-picker-input">
      <Popover
        open={visible}
        trigger={["click"]}
        placement="topLeft"
        onOpenChange={(vis) => setVisible(vis)}
        classNames={{ root: "popover-color-picker" }}
        content={<Chrome onChange={({ hex }) => handleColorChange(hex)} color={value || "#000000"} />}
      >
        <Input
          ref={inputRef}
          placeholder={t(placeholder)}
          onChange={(e) => handleColorChange(e.target.value)}
          value={value}
        />
      </Popover>
      {value && <div className="square" style={{ backgroundColor: value }} />}
    </div>
  );
};

export default ColorPicker;
